import { useRef, useState } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ModalPop from "./ModalPop";
import FlowText from "./FlowText";
import axios from "axios";
import Swal from "sweetalert2";

interface Slide {
  id: number;
  textImg: string;
  womanImg: string;
  alt: string;
}

const slides: Slide[] = [
  {
    id: 1,
    textImg: "/images/bannerTxt1.png",
    womanImg: "/images/bannerIcon1.png",
    alt: "과잉견적 절대 NO! 고객기만 절대 NO! 무조건 싸기만 한 업체는 믿을 수 없습니다. 필요한 견적만 정확하게 산출하여 딱 일한 만큼만 받는 정직한 업체 바우하우스",
  },
  {
    id: 2,
    textImg: "/images/bannerTxt2.png",
    womanImg: "/images/bannerIcon2.png",
    alt: "출장비용 ZERO! 고객부담 ZERO! 바우하우스는 전국 지사망을 활용하여 문의 접수시 가장 가까운 지사에서 현장으로 출장견적을 위해 달려갑니다",
  },
  {
    id: 3,
    textImg: "/images/bannerTxt3.png",
    womanImg: "/images/bannerIcon3.png",
    alt: "단순문의 OKAY! 정보제공 OKAY! 어떤 질문도 괜찮습니다. 가격, 절차, A/S, 기타 어떤 종류의 질문도 바우하우스에선 친절히 답변드립니다",
  },
];
// Shared form fields — used in both the sidebar card and the popup modal
function InquiryFields({ compact = false }: { compact?: boolean }) {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");

  // const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        address: address,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <input
          type="text"
          value={name}
          id="name1"
          onChange={(e) => setName(e.target.value)}
          placeholder="이름을 입력하세요"
          className="col-span-1 rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-center text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="tel"
          value={phone}
          id="phone1"
          maxLength={11}
          onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))}
          placeholder="연락처를 입력하세요"
          className="col-span-1 rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-center text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>
      <input
        type="text"
        id="address1"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        placeholder="주소를 입력하세요"
        className="w-full rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-center text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <label className="flex items-center justify-start gap-2 py-1 text-sm text-gray-600">
        <input
          defaultChecked
          checked
          type="checkbox"
          className="h-4 w-4 rounded-full border-gray-300 text-primary focus:ring-primary"
        />
        개인정보 처리방침 동의
      </label>
      <button
        type="button"
        onClick={handlerPostContact}
        className="w-full rounded-md bg-primary py-2 text-lg text-white transition-colors hover:bg-[#e0690f]"
      >
        무료 상담요청
      </button>
      {!compact && (
        <p className="pt-2 text-xs leading-relaxed">
          입력하신 정보를 다시한번 확인해 주시기 바랍니다.
          <br />
          문의 후 <span className="text-primary">평균 10분 내로 확인</span>
          하여 연락드립니다
          <br />
          출장견적 요청시 <span className="text-primary">가장 가까운 지사에서 바로 출발</span>
          합니다
        </p>
      )}
    </>
  );
}

// Fixed sidebar inquiry card — always in the same place, never slides
function InquiryCard() {
  return (
    <div className="w-full max-w-md shrink-0 rounded-3xl border-4 border-primary bg-white p-6 shadow-sm">
      <div className="mb-5 flex items-center justify-center gap-2">
        <img src={"/images/logo.png"} alt="바우하우스 BAUHAUS 로고" className="h-16 w-auto" />
      </div>
      <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
        <InquiryFields />
      </form>
    </div>
  );
}

const Banner = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <section className="w-full bg-white pt-10 px-[calc((100%-var(--container))/2)] max-w-[2300px] mx-auto">
        <div id="banner" className="mx-auto flex flex-col lg:flex-row lg:items-center xl:pr-16 3xl:pr-40">
          {/* Rotating area: left text image + center woman image */}
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop
            className="w-full flex-1"
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className="lg:flex min-h-[360px] items-center justify-between sm:min-h-[420px] md:min-h-[460px]">
                  <button
                    type="button"
                    onClick={openfunc}
                    className="shrink-0 transition-opacity hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary mx-auto 3xl:mr-0"
                    aria-label="무료 상담 신청 팝업 열기"
                  >
                    <img src={slide.textImg} alt={slide.alt} className="relative w-full h-auto lg:max-w-[520px]" />
                  </button>
                  <img
                    src={slide.womanImg}
                    alt=""
                    aria-hidden="true"
                    className="h-full max-h-[250px] w-auto object-contain block md:max-h-[400px] lg:max-h-[520px] mx-auto 3xl:mr-0"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Fixed inquiry card — sits outside the Swiper, so it never rotates */}
          <div className="flex justify-center lg:block -mt-20 lg:mt-0 2xl:-ml-16 3xl:-ml-26 z-10">
            <InquiryCard />
          </div>
        </div>
        <ModalPop popupRef={popupRef} closefnc={closefunc} />
      </section>
      <div className="relative w-full h-full bg-light py-4 px-[calc((100%-var(--container))/4)]">
        <FlowText />
      </div>
    </>
  );
};

export default Banner;
